import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IMaskModule } from 'angular-imask';
import { AccordionModule } from 'primeng/accordion';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CalendarModule } from 'primeng/calendar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { InplaceModule } from 'primeng/inplace';
import { ToastModule } from 'primeng/toast';
import { MetaGovernoRoutingModule } from './meta-governo-routing.module';
import { MetaGovernoLstComponent } from './meta-governo-lst/meta-governo-lst.component';
import { MetaGovernoShwComponent } from './meta-governo-shw/meta-governo-shw.component';
import { SharedModule } from 'eddydata-lib';



@NgModule({
  declarations: [MetaGovernoLstComponent, MetaGovernoShwComponent],
  imports: [
    CommonModule,
    MetaGovernoRoutingModule,
    SharedModule,
    FormsModule,
    AutoCompleteModule,
    AccordionModule,
    CalendarModule,
    IMaskModule,
    ToastModule,
    ConfirmDialogModule,
    InplaceModule
  ],
  providers: [MessageService, ConfirmationService]
})
export class MetaGovernoModule { }
